import React from "react";
import { FindTariffsWithPhone } from "ComponentsUI/Navigation";
import { sendMetriks } from "Services/sendMetriks";
import Metrika from "Services/Metrika";
import { SUCCESS_SEARCH_ADDRESS_PROVIDER_COVERAGE } from "Constants/metriks/Yandex";
import {
    EVENT_CATEGORY_CLICK_BUTTON,
    EVENT_CATEGORY_PAGE_VIEW,
} from "Constants/metriks/GoogleCategorys";
import {
    EVENT_SUCCESS_SEARCH_COVERAGE_PROVIDER,
    CLICK_LOAD_CALLBACK,
} from "Constants/metriks/GoogleActions";

export default class extends React.Component {
    componentDidMount() {
        sendMetriks("OPEN_ORDER_FORM");
        Metrika.getInstance().google.sendEvent(
            EVENT_CATEGORY_PAGE_VIEW,
            CLICK_LOAD_CALLBACK
        );
    }

    successSearchCallback() {
        Metrika.getInstance().google.sendEvent(
            EVENT_CATEGORY_CLICK_BUTTON,
            EVENT_SUCCESS_SEARCH_COVERAGE_PROVIDER
        );
    }

    render() {
        let text = this.props.text;
        let decl = this.props.declinations;
        let header = `${text.FIND_TARIFFS_IN_TOWN_1} ${decl.prepositional} ${text.FIND_TARIFFS_IN_TOWN_2}`;
        return (
            <FindTariffsWithPhone
                {...this.props}
                header={header}
                typeB={true}
                successCallback={() => this.successSearchCallback()}
                datatestForAddressButton={"find_tohome_button_popup"}
            />
        );
    }
}
